export default __webpack_public_path__ + "0f3ad01f5031e4616e8aaab2e8901ad2.png";